import { useCallback, useEffect, useState } from "react";
import hasValidData from "@/core/utils/hasValidData";
import useSettingsProvider from "@/core/dataProviders/providers/app/useSettingsProvider";
import useUserProvider from "@/core/dataProviders/providers/auth/useUserProvider";
import useUserSubscriptionProvider from "@/core/dataProviders/providers/auth/useUserSubscriptionProvider";
import { FEATURE_PERMISSIONS } from "@/core/types/permissions";

type OfflineImageContent = {
  displayBranding: boolean;
};

export const useBrandingAdsChecker = (): OfflineImageContent => {
  const [settings, settingsReqState] = useSettingsProvider();
  const initialSwitchAdds = hasValidData(settings, settingsReqState) ? settings.brandingAds : false;
  const [user] = useUserProvider();
  const [subscriptions] = useUserSubscriptionProvider();

  const [displayBranding, setDisplayBranding] = useState<boolean>(initialSwitchAdds);

  const brandingFreeChecker = useCallback(() => {
    if (user && subscriptions) {
      return subscriptions?.some((sub) => sub.access.includes(FEATURE_PERMISSIONS.ADS_FREE));
    }
  }, [subscriptions, user]);

  useEffect(() => {
    if (displayBranding && brandingFreeChecker()) {
      setDisplayBranding(false);
    }

    if (!displayBranding && !brandingFreeChecker() && hasValidData(settings, settingsReqState)) {
      setDisplayBranding(settings.brandingAds);
    }
  }, [brandingFreeChecker, displayBranding, settings, settingsReqState]);

  return { displayBranding };
};
